module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-service"
  }, [_c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("我的长沙")]), _vm._v(" "), _c('div', {
    staticClass: "ctx"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "item",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.menuClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.menuName))]), _vm._v(" "), _c('wx-open-launch-weapp', {
      staticStyle: {
        "height": "100%",
        "width": "100%",
        "position": "absolute",
        "top": "0",
        "left": "0",
        "z-index": "10"
      },
      attrs: {
        "id": "launch-btn",
        "username": "gh_7f57f7d2417e",
        "path": item.url
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t<div style=\"height: 2rem;width: 2rem;opacity: 0\"></div>\n\t\t\t\t\t\t")])])], 1)
  }))]), _vm._v(" "), (_vm.isShowDialog) ? _c('DetailDialog', {
    attrs: {
      "show": _vm.isShowDialog,
      "title": _vm.dialogTitle,
      "list": _vm.dialogList
    },
    on: {
      "close": _vm.closeDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a71e1dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/provincial_level/my_cs_service/my_cs_service.vue
// module id = 308
// module chunks = 40